// extracted by mini-css-extract-plugin
export default {"containerContent":"Features_containerContent__+P3GZ","containerSection":"Features_containerSection__ABG7l","containerMotion":"Features_containerMotion__8AW0d"};